import * as React from 'react';
const SvgVolumeSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M3.293 4.707a1 1 0 0 1 1.414-1.414l16 16a1 1 0 0 1-1.414 1.414zM5.473 9.464A.75.75 0 0 1 6.172 9L14 16.828V18.5a.5.5 0 0 1-.835.37L9 15H6.18a.75.75 0 0 1-.707-.464A7 7 0 0 1 5 12c0-.894.168-1.75.473-2.536M10.466 7.638 14 11.172V5.49c0-.433-.513-.65-.835-.36zM16.266 13.437l1.15 1.15c.374-.783.584-1.66.584-2.587 0-1.513-.56-2.895-1.484-3.95a.38.38 0 0 0-.556-.01l-.495.495a.43.43 0 0 0-.013.578A4.48 4.48 0 0 1 16.5 12c0 .503-.082.986-.234 1.437"
    />
    <path
      fill="currentColor"
      d="m18.527 15.698 1.093 1.093a8.96 8.96 0 0 0 1.38-4.79 8.97 8.97 0 0 0-2.36-6.076.387.387 0 0 0-.559-.006l-.495.495a.417.417 0 0 0-.008.573A7.47 7.47 0 0 1 19.5 12a7.47 7.47 0 0 1-.974 3.698"
    />
  </svg>
);
export default SvgVolumeSlash;
